import React from 'react';
import { Button, DialogActions, DialogContent } from '@mui/material';

/**
 * @typedef {object} LicenseEditDialogProps
 * @property {React.ReactNode} [dialogContent]
 * @property {React.ReactNode} [dialogActions]
 */

/**
 * @param {LicenseEditDialogProps} props
 */
const LicenseEditDialog = props => {
  const { dialogContent, dialogActions } = props;

  return (
    <>
      <DialogContent>{dialogContent}</DialogContent>

      <DialogActions>
        {dialogActions}

        <Button className='primary-button sm' disabled>
          Save
        </Button>
      </DialogActions>
    </>
  );
};

export default LicenseEditDialog;
